
import './App.css';
import MaxiProfile from "./components/Profile/MaxiProfile";
import {IntlProvider} from 'react-intl';

import {convertLangFile, getBrowserLanguage} from './i18n/defineMessages';
import React, {useState} from "react";
import {AuthContext} from "./contexts/auth/AuthContext";
import {LoadingContext} from "./contexts/loading/LoadingContext";
import LoadingSpinner from "./components/Loading/LoadingSpinner";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import Login from "./components/Login/Login";
import DailyCheckIn from "./components/DailyCheckIn/DailyCheckIn";
import {getLangFile, LanguageContext} from "./contexts/language/LanguageContext";
import InfoModal from "./components/InfoModal/InfoModal";
import {ModalContext} from "./contexts/modal/ModalContext";
import MessageBoard from "./components/MessageBoard/MessageBoard";
import LearningProgress from "./components/LearningProgress/LearningProgress";
import {NavContext} from "./contexts/navigation/NavContext";
import LearnGame from "./components/LearnGame/LearnGame";




function App() {
    const locale = getBrowserLanguage();
    const langFile = getLangFile(locale);

    const langMsg = convertLangFile(langFile, 'maxi-ding');

    const initialAuthState = {
        isAuthenticated: false,
        user: null,
        email: null,
        token: null,
    };

    const initialLoadingState = {
        isLoading: false,
        loadingText: '',
    };

    const initialLangState = {
        locale: locale,
        langMsg: langMsg,
    };

    const initialModalState = {
        isShow: false,
        title: '',
        content: '',
        onConfirm: () => {},
    };


    const [authContext, setAuthContext] = useState({...initialAuthState});
    const [loadingContext, setLoadingContext] =
        useState({...initialLoadingState});
    const [langContext, setLangContext] = useState({...initialLangState});
    const [modalContext, setModalContext] = useState({...initialModalState});
    const [navContext, setNavContext] = useState("/");

    return (
        <IntlProvider locale={langContext.locale} messages={langContext.langMsg}>
            <AuthContext.Provider value={[authContext, setAuthContext]}>
                <LoadingContext.Provider value={[loadingContext, setLoadingContext]}>
                    <LanguageContext.Provider value={[langContext, setLangContext]}>
                        <ModalContext.Provider value={[modalContext, setModalContext]}>
                            <NavContext.Provider value={[navContext, setNavContext]}>
                                <div className="App">
                                    {loadingContext.isLoading && <LoadingSpinner loadingText={loadingContext.loadingText}/>}
                                    <BrowserRouter>
                                        <Routes>
                                            <Route path="/" element={<MaxiProfile/>}/>
                                            <Route path="/login" element={<Login/>}/>
                                            <Route path="/checkin" element={<DailyCheckIn/>}/>
                                            <Route path="/message" element={<MessageBoard/>}/>
                                            <Route path="/learning" element={<LearningProgress/>}/>
                                            <Route path="/game" element={<LearnGame/>}/>
                                        </Routes>
                                    </BrowserRouter>
                                    <InfoModal />
                                </div>
                            </NavContext.Provider>
                        </ModalContext.Provider>
                    </LanguageContext.Provider>
                </LoadingContext.Provider>
            </AuthContext.Provider>
        </IntlProvider>

    );
}

export default App;
